import React from "/vendor/react";
import PropTypes from "prop-types";
import { makeStyles } from "/vendor/@material-ui/core";

import { ReplayIcon } from "/lib/component/icon";

const useStyles = makeStyles((theme) => ({
  column: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    marginTop: 2,
    padding: 0,
    border: "none",
    borderRadius: 4,
    background: "transparent",
    color: theme.palette.text.secondary,
    cursor: "pointer",
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 120ms ease-in-out",
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "&:focus": {
      opacity: 1,
      pointerEvents: "auto",
      color: theme.palette.primary.main,
      outline: "none",
    },
  },
  visible: {
    opacity: 1,
    pointerEvents: "auto",
  },
}));

// Sits under the status icon. Hidden until the row is hovered (or the
// button itself receives keyboard focus).
const EventRowRerunIcon = ({ children, visible, disabled, onClick }) => {
  const classes = useStyles();

  const handleClick = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    onClick();
  };

  return (
    <span className={classes.column}>
      {children}
      {!disabled && (
        <button
          type="button"
          className={`${classes.button} ${visible ? classes.visible : ""}`}
          aria-label="Re-run"
          title="Re-run"
          onClick={handleClick}
        >
          <ReplayIcon fontSize="small" />
        </button>
      )}
    </span>
  );
};

EventRowRerunIcon.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

EventRowRerunIcon.defaultProps = {
  visible: false,
  disabled: false,
};

export default EventRowRerunIcon;
